module.exports = __webpack_public_path__ + "img/headphone_300.3a98d4e3.png";